import axios from "axios"
import { requests } from "../config";
import { ICreateProblemData, ITeudotWithDetailsAndProblems, IProblemWithDetailsNew, IProblemListItem } from "./models/problems";
import { IApproveProblemBulkData, IApproveProblemData, IReportQueryParams } from "./models/requests";
import { IReportTable } from "../../../main/second/mainbar/teudotProblems/Reports/types/table";

export const TEUDOT_PROBLEMS = {
  deleteProblem: (recId: number | string): Promise<void> => requests.delete(`problem/${recId}`, 'go'),
  getProblemList: (): Promise<IProblemListItem[]> => requests.get('tbl/ProblemTypes', 'go'),
  getTeudotProblems: () => {
    return axios.get('/api/teudot-problems')
  },
  createProblem: (data: ICreateProblemData): Promise<IProblemWithDetailsNew> => requests.post('problem', 'go', data),
  updateProblem: (data: ICreateProblemData) => requests.put('problem', 'go', data),
  getDeliveriesWithPalletDetailsAndProblems: (dateParams: string): Promise<ITeudotWithDetailsAndProblems[]> => 
    requests.get(`problem/deliveries/pallet_details_with_problems?${dateParams}`, 'go'),
  getProblemsByDateRange: (dateParams: string): Promise<IProblemWithDetailsNew[]> => 
    requests.get(`problem?${dateParams}`, 'go'),
  approveProblem: (data: IApproveProblemData) => requests.put('problem/approve', 'go', data),
  approveProblemForDriver: (recID: number, status: number, isLine?: boolean) => 
    requests.put(`/problem/${recID}/approve_by_driver`, 'go', {DriverStatus: status, IsLine: !!isLine}),
  bulkApproveProblemsForDriver: (customerID: number, status: number) => 
    requests.put(`problem/${customerID}/bulk_approve_by_driver`, 'go', {DriverStatus: status}),
  bulkApproveProblems: (data: IApproveProblemBulkData): Promise<IProblemWithDetailsNew> => requests.put('problem/approve/all', 'go', data),
  getReports: (data: string): Promise<IReportTable> => 
    requests.get(`problem/report?${data}`, 'go'),
}

